import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Menu from "./components/Menu";
import Combos from "./components/Combos";
import Gallery from "./components/Gallery";
import Locations from "./components/Locations";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import OrderPage from "./components/OrderPage";
import DeliveryNotification from "./components/DeliveryNotification";

const HomePage = () => {
  return (
    <>
      <Header />
      <Hero />
      <About />
      <Menu />
      <Combos />
      <Gallery />
      <Locations />
      <Contact />
      <Footer />
      <DeliveryNotification />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/order" element={<OrderPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
